var map = {
	"./background.png": "b874",
	"./peach.png": "f432",
	"./peach_0.png": "78bd",
	"./peach_1.png": "b459",
	"./peach_2.png": "4af9",
	"./peach_3.png": "cd70",
	"./plum.png": "b74b",
	"./plum_0.png": "cc75",
	"./plum_1.png": "8ce2",
	"./plum_2.png": "6407",
	"./plum_3.png": "3489",
	"./soil.png": "fe97",
	"./soil_0.png": "0351"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";